/*! Wi-chat - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

var url_chat, url_chat_messages, url_chat_save, url_chat_delete, chat_scroll_l, chat_scroll_t;
+function ($) {
    'use strict';
    var wiChat = window.wiChat;
    window.wiChat = {
        init: function () {
            wiChat.events.init();
        },
        refresh: function () {
            wiPlugins.refresh();
        },
        events: {
            init: function () {
                wiChat.events.refresh();
                $(document).on('show.bs.tab', '.tab-chat', function () {
                    var ajaxloaded = $(this).attr('data-ajax-loaded');
                    if (ajaxloaded === 'false') {
                        $(this).attr('data-ajax-loaded', true);
                        wiVars.set.variable('subreferral_id', 0);
                        wiVars.set.variable('subreferral_type', '');
                        wiVars.set.variables();
                        wiChat.get.chat();
                    }
                });
                $(document).off('click', '.chat-edit').on('click', '.chat-edit', function (e) {                    
                    e.preventDefault();

                    const chatId = $(this).data('id');

                    const $content = $(this).closest('.chat').find('.chat-content');
                    const content = $content.html() || '';

                    const $editorContainer = $('#chat-form');
                    const $form = $editorContainer.find('form');
                    const $summernote = $editorContainer.find('.summernote');

                    const $editingArea = $editorContainer.find('.note-editing-area');

                    wiChat.resetForm($form);

                    $('<div class="note-reply-block"></div>').html(`
                        <button type="button" class="note-reply-close" title="${lang.editor_cancel}">&times;</button>
                        <div class="note-reply-content">
                            <strong><i class="fa fa-edit fa-fw"></i> ${lang.editor_editing}:</strong>
                        </div>
                    `).insertBefore($editingArea.find('.note-editable'));

                    $form.find('input[name="chat_id"]').val(chatId);
                    $form.find('input[name="action"]').val('edit');
                    
                    $summernote.summernote('pasteHTML', content);
                    $summernote.summernote('focus');
                });
                $(document).off('click', '.chat-confirm-delete').on('click', '.chat-confirm-delete', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var chat_id = $(this).attr('data-id');
                    wiModal.get({
                        modal: 'chat_delete_confirmation',
                        module: 'chat/chat_project_manager',
                        langauge_id: language_id,
                        referral_id: chat_referral_id,
                        referral_type: chat_referral_type,
                        subreferral_id: chat_subreferral_id,
                        subreferral_type: chat_subreferral_type,
                        chat_id: chat_id
                    });
                });
                $(document).on('click', "#chat_delete_btn", function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    var form_data = $("#chat_delete_form").serialize();
                    $.ajax({
                        url: url_chat_delete,
                        type: 'POST',
                        data: form_data,
                        success: function (jData) {
                            $('#chat_delete_confirmation').modal('hide');
                            wiChat.get.messages();
                            wiAlerts.add(jData.status, jData.title, jData.msg);
                        }
                    });
                });
                $(document).on('submit', '#form_chat', function (e) {
                    e.preventDefault();

                    const form = e.target; 
                    if (!(form instanceof HTMLFormElement)) {
                        console.error('The event target is not a form element.');
                        return;
                    }

                    const $form = $(form);

                    const btn = form.querySelector('.note-btn-send');
                    if (!btn)
                        return;

                    const icon = btn.querySelector('.fa');
                    const originalIconClass = 'fa-paper-plane';

                    btn.disabled = true;
                    icon?.classList.remove(originalIconClass);
                    icon?.classList.add('fa-spinner', 'fa-spin');

                    const formData = new FormData(form);

                    const $editor = $form.find('.summernote');

                    let cleanedHTML = '';
                    if (!$editor.summernote('isEmpty')) {
                        cleanedHTML = $editor.summernote('code').trim();

                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = cleanedHTML;
                        tempDiv.querySelectorAll('.attached-file').forEach(el => el.remove());
                        tempDiv.querySelectorAll('.pasted-wrapper').forEach(wrapper => {
                            // Move children out of the wrapper
                            while (wrapper.firstChild) {
                                wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                            }
                            wrapper.remove();
                        });
                        cleanedHTML = tempDiv.innerHTML.trim();
                    }

                    formData.set('message', cleanedHTML);
                    
                    formData.delete('userfiles[]');
                    const files = window.fileStore?.get(form) || [];
                    files.forEach(file => formData.append('userfiles[]', file));

                    fetch(url_chat_save, {
                        method: 'POST',
                        body: formData,
                    })
                            .then(res => res.json())
                            .then(jData => {
                                btn.disabled = false;
                                icon?.classList.remove('fa-spinner', 'fa-spin');
                                icon?.classList.add(originalIconClass);

                                if (jData.status === 'success') {
                                    wiChat.resetForm($form);
                                    wiVars.set.from.response(jData);
                                    wiChat.get.messages();
                                }

                                if (typeof wiAlerts !== 'undefined') {
                                    wiAlerts.add(jData.status, jData.title, jData.msg);
                                }
                                wiComments.events.refresh();
                                if (typeof wiActivity !== 'undefined') {
                                    wiActivity.get(chat_referral_id, chat_referral_type);
                                }
                            })
                            .catch(error => {
                                console.error('Chat submit error:', error);
                                btn.disabled = false;
                                icon?.classList.remove('fa-spinner', 'fa-spin');
                                icon?.classList.add(originalIconClass);
                            });
                });
            },
            refresh: function () {
                $('#chat-messages-inner').scroll(function () {
                    chat_scroll_l = $(this).scrollLeft();
                    chat_scroll_t = $(this).scrollTop();
                });
            }
        },
        resetForm($form) {
            if (!$form) return;

            const $summernote = $form.find('.summernote');
            $summernote.summernote('code', '');
            
            $form.find('textarea[name="message"]').val('');
            $form.find('input[name="chat_id"]').val(0);
            $form.find('input[name="action"]').val('create');
            
            $form.find('.attached-file').remove();
            $form.find('.comment_file').val('');
            $form.find('.attached-files-meta').val('[]');

            $form.find('.note-reply-block').remove();

            window.fileStore.set($form[0], []);
        },
        get: {
            chat: function () {
                $.get(
                        url_chat,
                        {
                            language_id: language_id,
                            referral_id: chat_referral_id,
                            referral_type: chat_referral_type,
                            subreferral_id: chat_subreferral_id,
                            subreferral_type: chat_subreferral_type,
                            csrf_wicode: csrf_value
                        },
                        function (data) {

                            var chat_area = $('#chat_area');
                            chat_area.html(data.chat);
                            wiChat.refresh();
                            wiChat.get.messages();
                            setInterval(function () {
                                wiChat.get.messages();
                            }, 10000);
                        }
                );
            },
            messages: function () {
                $.get(
                        url_chat_messages,
                        {
                            language_id: language_id,
                            referral_id: chat_referral_id,
                            referral_type: chat_referral_type,
                            subreferral_id: chat_subreferral_id,
                            subreferral_type: chat_subreferral_type,
                            csrf_wicode: csrf_value
                        },
                        function (data) {
                            var messages_area = $('#chat-messages');
                            messages_area.html(data.messages);
                            wiChat.events.refresh();
                            $('#chat-messages-inner').scrollLeft(chat_scroll_l);
                            $('#chat-messages-inner').scrollTop(chat_scroll_t);
                        }
                );
            }
        }
    };
    $(function () {
        url_chat = urls.chat + '/get_chat';
        url_chat_messages = urls.chat + '/get_chat_messages';
        url_chat_save = urls.chat + '/save';
        url_chat_delete = urls.chat + '/delete';

        wiChat = window.wiChat;
        wiChat.init();
    });
}(jQuery);
